import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=0585ff6b&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"
import style0 from "./forgetPassword.vue?vue&type=style&index=0&id=0585ff6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0585ff6b",
  null
  
)

export default component.exports